import type { SVGProps } from "react";
const SvgVariables = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 26 26" {...props}>
    <g stroke="currentColor" clipPath="url(#variables_svg__a)">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m22.5 9.5 3 3.5-3 3.5m-19-7L.6 13l2.9 3.5m13-3v2m0-2v-3h2l1 1.5-1 1.5m-2 0h2m-4 2L14 14m0 0h-3m3 0-1.5-3.5L11 14m0 0-.5 1.5m-1-5-2 5-2-5m13 3 1 2"
      />
      <path d="m.5 25 3.354-3.354a.5.5 0 0 1 .353-.146h17.586a.5.5 0 0 1 .353.146L25.5 25M25.5 1l-3.354 3.354a.5.5 0 0 1-.353.146H4.207a.5.5 0 0 1-.353-.146L.5 1" />
    </g>
    <defs>
      <clipPath id="variables_svg__a">
        <path className="icon-color-4" fill="#fff" d="M0 0h26v26H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVariables;
